import React from 'react';
import './Footer.css';
import googlePlay from '../../assets/Images/google-play.png';
import appStore from '../../assets/Images/app-store.png';
import qrCode from '../../assets/Images/qr-code.png';

const Footer = () => {
  return (
    <footer className="footer">
      {/* <div className="footer-container">
        <div className="footer-section">
          <h3>Near</h3>
          <ul>
            <li><a href="/support">Support</a></li>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="/help">Help Centre</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/terms">Terms & Conditions</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Financial Services</h3>
          <ul>
            <li><a href="/fee-free">Fee Free</a></li>
            <li><a href="/pay">Pay</a></li>
            <li><a href="/settlements">Settlements</a></li>
            <li><a href="/payment-links">Payment Links</a></li>
            <li><a href="/loan-repayment">Loan Repayment</a></li>
            <li><a href="/credit-card">Credit Card</a></li>
            <li><a href="/insurance">Insurance</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <ul className="additional-services">
            <li><a href="/active-qr">Active QR</a></li>
            <li><a href="/pos">POS</a></li>
            <li><a href="/vendor-payments">Vendor Payments</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Recharges & Paybills</h3>
          <ul>
            <li><a href="/mobile-recharge">Mobile Recharge</a></li>
            <li><a href="/fastag">FASTag</a></li>
            <li><a href="/mobile-postpaid">Mobile Postpaid</a></li>
            <li><a href="/municipal-tax">Municipal Tax</a></li>
            <li><a href="/broadband">Broadband & Landline</a></li>
            <li><a href="/lpg-cylinder">LPG Cylinder</a></li>
            <li><a href="/electricity">Electricity Bill</a></li>
            <li><a href="/dth">DTH</a></li>
            <li><a href="/piped-gas">Piped Gas</a></li>
            <li><a href="/water">Water</a></li>
          </ul>
        </div>

  
        <div className="footer-section download-section">
          <h3>Download</h3>
          <div className="qr-code">
            <img src={qrCode} alt="QR Code" />
          </div>
          <div className="app-buttons">
            <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
              <img src={googlePlay} alt="Get it on Google Play" />
            </a>
            <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer">
              <img src={appStore} alt="Download on App Store" />
            </a>
          </div>
          <div className="follow-us">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <a href="#" className="social-icon facebook"></a>
              <a href="#" className="social-icon twitter"></a>
              <a href="#" className="social-icon instagram"></a>
              <a href="#" className="social-icon youtube"></a>
              <a href="#" className="social-icon linkedin"></a>
              <a href="#" className="social-icon telegram"></a>
            </div>
          </div>
        </div>
      </div> */}
    </footer>
  );
};

export default Footer; 